import React, { Component } from 'react';
// import Select from 'react-select';
import { connect } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import SettingsNavBar from './SettingsNavBar';
import SideBar from '../../components/SideBar';
import { updateUser, clearUserStatuses } from '../../actions';
import { ages, jobs } from '../../accountOptions';

class Demographics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showError: false,
      age: this.props.age,
      occupation: this.props.occupation,
    };
  }

  componentDidMount() {
    this.props.clearUserStatuses();
  }

  componentWillUnmount() {
    this.props.clearUserStatuses();
  }

  handleChange = (event) => {
    this.props.clearUserStatuses();
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = () => {
    this.props.clearUserStatuses();
    if (this.state.age && this.state.occupation) {
      this.props.updateUser(this.props.userid, {
        age: this.state.age,
        occupation: this.state.occupation,
      });
      this.setState({ showError: false });
    } else {
      this.setState({ showError: true });
    }
  }

  render() {
    return (
      <div className="flex-container">
        <SideBar defaultPage="account" />
        <SettingsNavBar defaultPage="demographics" />
        <div className="profile-container">
          <h2 className="color account-header">Demographics</h2>
          <div className="profile-body-container">
            <div className="box profile-form-container">
              <div className="demographic-row-container">
                <p className="color">Age</p>
                <Select
                  labelId="-controlled-open-select-label"
                  id="-controlled-open-select"
                  name="age"
                  onChange={this.handleChange}
                  value={this.state.age}
                >
                  {ages.map((age) => (
                    <MenuItem value={age}>{age}</MenuItem>
                  ))}
                </Select>
              </div>
              <div className="demographic-row-container">
                <p className="color">Currently, I am</p>
                <Select
                  labelId="demo-controlled-open-select-label"
                  id="demo-controlled-open-select"
                  name="occupation"
                  onChange={this.handleChange}
                  value={this.state.occupation}
                >
                  {jobs.map((job) => (
                    <MenuItem value={job}>{job}</MenuItem>
                  ))}
                </Select>
              </div>
              <br />
              {this.state.showError ? <p className="settings-error-text">Please fill in both fields</p> : null}
              {this.props.updateError ? <p className="settings-error-text">There was an error updating your profile</p> : null}
              {this.props.successMsg ? <p className="settings-success-text">Your profile has been successfully updated</p> : null}
              <button onClick={this.handleSubmit} className="save-button" type="button">Save</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userid: state.user.userid,
  age: state.user.age,
  occupation: state.user.occupation,
  updateError: state.user.updateError,
  successMsg: state.user.updateSuccess,
});

export default connect(mapStateToProps, { updateUser, clearUserStatuses })(Demographics);
